import Box from '@mui/material/Box';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { typedMemo } from '@utils';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { BaseControllerProps } from './types';

interface CheckboxFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends Omit<CheckboxProps, 'name' | 'value' | 'onChange' | 'checked'>,
    BaseControllerProps<TFieldValues, TName> {
  label?: string;
}

export const CheckboxFormField = typedMemo(
  <
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
  >({
    name,
    control,
    rules,
    label,
    ...checkboxProps
  }: Readonly<CheckboxFormFieldProps<TFieldValues, TName>>) => {
    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <Box>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  {...checkboxProps}
                  checked={field.value || false}
                />
              }
              label={label}
            />
            {error && (
              <FormHelperText error sx={{ ml: 0 }}>
                {error.message}
              </FormHelperText>
            )}
          </Box>
        )}
      />
    );
  },
);
